import { PluginInitializerService } from 'core-client/api'
import { MapService } from "./map.service";

export function mapInitializerFactory(MapService: MapService, configService: PluginInitializerService): () => Promise<void> {
  return () =>
    new Promise<void>((resolve) => {
      const init = async () => {
        await MapService.setup();
      };

      configService.setup('map', init, resolve);
    });
}
